import { useEffect } from "react";

interface UseLoadingStateOptions {
  isLoading: boolean;
  preventScroll?: boolean;
}

export function useLoadingState({
  isLoading,
  preventScroll = true,
}: UseLoadingStateOptions) {
  useEffect(() => {
    if (!preventScroll || !isLoading) return;

    // Store original overflow style
    const originalStyle = window.getComputedStyle(document.body).overflow;

    // Prevent scrolling on mobile
    document.body.style.overflow = "hidden";
    document.body.style.position = "relative";

    // Cleanup function
    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.position = "";
    };
  }, [isLoading, preventScroll]);
}
